export const BuildingStatuses = [
  { key: "Active", label: "Active" },
  { key: "Cancelled", label: "Cancelled" },
  { key: "Collection", label: "Collection" },
  { key: "Pending", label: "Pending" },
  { key: "Transferred", label: "Transferred" },
  { key: "Expired", label: "Expired" },
];

export const BuildingTypes = [
  { key: "Commercial", label: "Commercial" },
  { key: "Company/Office", label: "Company/Office" },
  { key: "Garage", label: "Garage" },
  { key: "Government", label: "Government" },
  { key: "Hospital", label: "Hospital" },
  { key: "Nursing Home", label: "Nursing Home" },
  { key: "Other", label: "Other" },
  { key: "Parent Location", label: "Parent Location" },
  { key: "Religious Facility", label: "Religious Facility" },
  { key: "Residential", label: "Residential" },
  { key: "Restaurant", label: "Restaurant" },
  { key: "School", label: "School" },
  { key: "Ship", label: "Ship" },
  { key: "Transportation Facility", label: "Transportation Facility" },
];

export const DispatchTypes = [
  { key: "Standard", label: "Standard" },
  { key: "Priority", label: "Priority" },
  { key: "Emergency", label: "Emergency" },
];

export const DeviceStatusLabels = [
  { value: "Waiting for Approval", label: "Waiting for Approval" },
  {
    value: "Approved - Schedule Inspection",
    label: "Approved - Schedule Inspection",
  },
  { value: "Scheduled - Perform Test", label: "Scheduled - Perform Test" },
  { value: "Performed - Enter Results", label: "Performed - Enter Results" },
  {
    value: "Results Entered - Out for Survey",
    label: "Results Entered - Out for Survey",
  },
  {
    value: "Proposal Sent - Waiting for Approval",
    label: "Proposal Sent - Waiting for Approval",
  },
  {
    value: "Job Approved - Route Mechanic",
    label: "Job Approved - Route Mechanic",
  },
  {
    value: "Job Approved - Schedule Work",
    label: "Job Approved - Schedule Work",
  },
  {
    value: "Work Completed - Progress AOC",
    label: "Work Completed - Progress AOC",
  },
  {
    value: "Work Completed - Building Items Open",
    label: "Work Completed - Building Items Open",
  },
  { value: "Work Pending - AOC Created", label: "Work Pending - AOC Created" },
  { value: "AOC Created", label: "AOC Created" },
  {
    value: "Work Pending - AOC Accepted DOB Now",
    label: "Work Pending - AOC Accepted DOB Now",
  },
  {
    value: "Corrected - Verified on DOB Website",
    label: "Corrected - Verified on DOB Website",
  },
  { value: "Unsatisfactory", label: "Unsatisfactory" },
  {
    value: "AOC Rejected - Sent to Customer",
    label: "AOC Rejected - Sent to Customer",
  },
  { value: "Device Removed", label: "Device Removed" },
  { value: "Cancelled Contract", label: "Cancelled Contract" },
  { value: "Work Completed", label: "Work Completed" },
  { value: "Modernization", label: "Modernization" },
  {
    value: "Priced Out - Create Proposal",
    label: "Priced Out - Create Proposal",
  },
  { value: "Satisfactory", label: "Satisfactory" },
  { value: "AOC Sent to Customer", label: "AOC Sent to Customer" },
  { value: "Rejected Performed", label: "Rejected Performed" },
  { value: "Rejection Sent to Customer", label: "Rejection Sent to Customer" },
  { value: "AOC Submitted from DOB", label: "AOC Submitted from DOB" },
  { value: "Work in Progress", label: "Work in Progress" },
  { value: "New Construction", label: "New Construction" },
  { value: "Test Not Approved", label: "Test Not Approved" },
  { value: "Unsatisfactory - Non DOB", label: "Unsatisfactory - Non DOB" },
  { value: "AOC Done by Others", label: "AOC Done by Others" },
  { value: "AOC in Process", label: "AOC in Process" },
  { value: "Test Not Showing Up", label: "Test Not Showing Up" },
  {
    value: "Test Approved - No Witness Company Given",
    label: "Test Approved - No Witness Company Given",
  },
  { value: "Outerboro", label: "Outerboro" },
  { value: "Failed - Shut Down", label: "Failed - Shut Down" },
  { value: "Construction Use", label: "Construction Use" },
  { value: "DLM", label: "DLM" },
  { value: "Unsatisfactory - Too Late", label: "Unsatisfactory - Too Late" },
  { value: "Out of Service", label: "Out of Service" },
  {
    value: "Letter of Completion Sent to BD/Custom",
    label: "Letter of Completion Sent to BD/Custom",
  },
  { value: "Reinspection Requested", label: "Reinspection Requested" },
  { value: "DLM - Not Signed", label: "DLM - Not Signed" },
  { value: "DLM - Problems", label: "DLM - Problems" },
  { value: "Westchester", label: "Westchester" },
  { value: "Yonkers", label: "Yonkers" },
  { value: "New Rochelle", label: "New Rochelle" },
  { value: "Connecticut", label: "Connecticut" },
  { value: "New Jersey", label: "New Jersey" },
  { value: "Fire Service", label: "Fire Service" },
  { value: "Hunter", label: "Hunter" },
  { value: "Long Island", label: "Long Island" },
];

export const DeviceTypeLabels = [
  { value: "Traction", label: "Traction" },
  { value: "Drum", label: "Drum" },
  { value: "Hydraulic", label: "Hydraulic" },
  { value: "Platform Lift", label: "Platform Lift" },
  { value: "Material Lift", label: "Material Lift" },
  { value: "Manlift", label: "Manlift" },
  { value: "Conveyor", label: "Conveyor" },
  { value: "Stairlift", label: "Stairlift" },
  { value: "Escalator", label: "Escalator" },
  { value: "Moving Walk", label: "Moving Walk" },
  { value: "Wheelchair Lift", label: "Wheelchair Lift" },
];
